// extracted by mini-css-extract-plugin
module.exports = {"blade-treaser-detailA":"First_blade-treaser-detailA__3WgXU"};